import Typography from "@portal/components/atoms/v2/typography";
import { GetFundColor } from "../helpers";
import { CustomFund } from "../helpers/MapFundsToList";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { LoadingFunds } from "./LoadingFunds";
import { GlobeComponent } from "@portal/components/atoms/globe/GlobeComponent";
import Icon from "@portal/components/atoms/icons";
import Link from "next/link";

interface Props {
  isDefaultLanguage: boolean;
  funds: CustomFund[];
  isLoading: boolean;
}

const ignoreFund = (fund: CustomFund) => {
  return fund.isin === "NOXXXXXXCASH" || fund.isin === "IE00BMWPZH81" || fund.isin === "IE0009MTA5P0";
};

export const SavingSuggestionFunds = ({ isDefaultLanguage, funds, isLoading }: Props) => {
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;

  if (isLoading) {
    return <LoadingFunds />;
  }

  return (
    <div className="flex flex-col mb-2 border rounded-lg bg-white p-2">
      <div className={`flex items-center`}>
        <div
          className="flex mr-3 ml-1 h-[24px] border rounded-xl min-w-[80px] my-1.5"
          style={{
            backgroundColor: "var(--color-white)",
            justifyContent: "start",
            border: "none",
          }}
        >
          <Typography variant="DescriptionBold">{texts.PAGE_14_COLUMN_HEADER}</Typography>
        </div>
        <div className="flex w-full truncate">
          <Typography className="truncate" variant="DescriptionBold">
            {texts.PAGE_14_COLUMN_HEADER_A}
          </Typography>
        </div>
        <div className="hidden justify-end md:flex">
          <Typography variant="DescriptionBold">{texts.PAGE_14_COLUMN_HEADER_B}</Typography>
        </div>
        <div className="hidden justify-end min-w-[60px] md:flex mr-5">
          <Typography variant="DescriptionBold">{texts.PAGE_14_COLUMN_HEADER_C}</Typography>
        </div>
        <div className="flex justify-end min-w-[70px]">
          <Typography variant="DescriptionBold">{texts.PAGE_14_COLUMN_HEADER_D}</Typography>
        </div>
        <div className="flex justify-end min-w-[70px]">
          <Typography variant="DescriptionBold">{texts.PAGE_14_COLUMN_HEADER_E}</Typography>
        </div>
      </div>
      {funds.map(fund => {
        return (
          <div className="flex items-center hover:bg-blueHover h-[50px] bt-1 border-grey" key={fund.isin}>
            <div
              className="flex mr-3 ml-1 h-[24px] border rounded-xl min-w-[80px] my-1.5"
              style={{
                backgroundColor: `${GetFundColor(fund.type)}`,
                justifyContent: "center",
              }}
            >
              <Typography>{fund.type}</Typography>
            </div>
            <div className="flex w-full truncate">
              <Typography className="truncate">{fund.name} </Typography>
            </div>
            <div className="hidden justify-end md:flex">
              <Typography>
                <GlobeComponent numGlobes={fund.morningstarSustainabilityRating} />
              </Typography>
            </div>
            <div className="hidden justify-end min-w-[60px] md:flex mr-5">
              <Typography>{fund.sfdrRating}</Typography>
            </div>
            <div className="flex justify-end min-w-[70px]">
              <Typography>{`${fund.percentage}%`}</Typography>
            </div>
            {ignoreFund(fund) ? (
              <div className="flex justify-end min-w-[70px]"></div>
            ) : (
              <div className="flex justify-end min-w-[70px]">
                <Link
                  target="_blank"
                  href={`https://doc.morningstar.com/LatestDoc.aspx?clientid=norne&key=388b5494c68c4cf1&isin=${fund.isin}&documenttype=74&language=467`}
                  prefetch={false}
                >
                  <Icon name={"paperClipIcon"} size="xsmall" />
                </Link>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
